import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const UpdateProfile = createAsyncThunk(
  "profile/UpdateProfile",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}user/update_profil/${data.id}`,
        {
          username: data.username,
          nama: data.nama,
          email: data.email,
          id_fakultas: data.id_fakultas,
          id_prodi: data.id_prodi,
          no_hp: data.no_hp,
          alamat: data.alamat,
          tahun_angkatan: data.tahun_angkatan,
          id_role: data.id_role,
          id_jenis_pembiayaan: data.id_jenis_pembiayaan,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      data.cb(response.data);
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const UpdatePassword = createAsyncThunk(
  "profile/UpdatePassword",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}user/change_password`,
        {
          password: data.password,
          new_password: data.newPassword,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      data.cb(response.data);
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const ResetPassword = createAsyncThunk(
  "profile/ResetPassword",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(`${api}user/reset_password`, {
        email: data.email,
        otp: data.otp,
        password: data.password,
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const profileSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get profile
    builder.addCase(UpdateProfile.pending, loadingHandler);
    builder.addCase(UpdateProfile.fulfilled, (state, action) => {
      fulfilledHandler(state, action, (state, action) => {
        fulfilledHandler(state, action, { isEdit: true });
      });
    });
    builder.addCase(UpdateProfile.rejected, rejectedHandler);
    // update password
    builder.addCase(UpdatePassword.pending, loadingHandler);
    builder.addCase(UpdatePassword.fulfilled, (state, action) => {
      fulfilledHandler(state, action, (state, action) => {
        fulfilledHandler(state, action, { isEdit: true });
      });
    });
    builder.addCase(UpdatePassword.rejected, rejectedHandler);
    // reset password
    builder.addCase(ResetPassword.pending, loadingHandler);
    builder.addCase(ResetPassword.fulfilled, (state, action) => {
      fulfilledHandler(state, action, (state, action) => {
        fulfilledHandler(state, action, { isEdit: true });
      });
    });
    builder.addCase(ResetPassword.rejected, rejectedHandler);
  },
});

export const { reset } = profileSlice.actions;
export default profileSlice.reducer;
